import { isRichTextValueConsideredEmpty } from '@uniformdev/richtext';

import { BottomCallToAction } from '@/libraries/design/patterns/bottom-call-to-action/src/bottom-call-to-action';
import { RichTextComponent } from '@/libraries/design/utils';

import type { RichTextNode } from '@uniformdev/richtext';

export interface UniformCallToActionProps {
	title: { root: RichTextNode };
	emphasisColor?: string;
	body?: { root: RichTextNode };
	buttonLabel?: string;
	buttonHref?: string;
	secondaryCtaLabel?: string;
	secondaryCtaHref?: string;
	secondaryCtaType?: 'link' | 'button';
}

const UniformCallToAction = (props: UniformCallToActionProps) => {
	return (
		<BottomCallToAction
			title={
				<RichTextComponent
					uniformRichText={{
						type: 'root',
						version: 1,
						children: props.title.root.children?.at(0)?.children,
					}}
				/>
			}
			emphasisColor={props.emphasisColor}
			body={
				!isRichTextValueConsideredEmpty(props.body) ? (
					<RichTextComponent uniformParameter="body" />
				) : undefined
			}
			button={
				props.buttonLabel && props.buttonHref
					? {
							href: props.buttonHref,
							label: props.buttonLabel,
							dataEventProps: {
								'data-product-key': 'uniform',
								'data-event-component': 'linkButton',
								'data-event-container': 'ctaSection',
								'data-event': 'clicked',
							},
						}
					: undefined
			}
			secondaryCta={
				props.secondaryCtaLabel && props.secondaryCtaHref
					? {
							href: props.secondaryCtaHref,
							label: props.secondaryCtaLabel,
							dataEventProps: {
								'data-product-key': 'uniform',
								'data-event-component': 'linkButton',
								'data-event-container': 'ctaSection',
								'data-event': 'clicked',
							},
						}
					: undefined
			}
			secondaryCtaType={props.secondaryCtaType}
		/>
	);
};

export default UniformCallToAction;
